import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Button, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import RecommendedVenue from "../../features/recommendedVenue";
import { ENUM_ROUTES } from "../../RoutesEnum";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageRecommendedVenue = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1>Manage Recommended Venue Storage</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Manage Recommended Venue Storage
          </p>
        </div>

        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Venue" {...a11yProps(0)} />
                <Tab label="Storage" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </div>
        </div>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search..."
                />
              </Box>
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => navigate(ENUM_ROUTES.ADD_RECOMMENDED_VENUE)}
              >
                <AddIcon /> Add
              </Button>
              <Button className="btn btn_primary">
                <DownloadIcon /> Export
              </Button>
            </div>
          </div>

          <RecommendedVenue type="pending" />
        </div>
      </MainContainer>
    </>
  );
};

export default ManageRecommendedVenue;
